export default {
  seoTitle: "Hankuk Rubber Tech Co., Ltd. - Industrial Rubber Products · Custom Rubber Molding · Compression Molding Manufacturer",
  hero: {
    badge: "Since 1975 · Engineering Partner",
    headline1: "Having trouble with",
    headline2: "rubber products?",
    subtitle: "With over 50 years of expertise, we solve our customers' challenges. No drawings? No problem. We analyze it together and build it together.",
    ctaInquiry: "Inquire about Products",
    ctaAbout: "About the Company",
    scroll: "Scroll",
    stats: [
      { label: "Years of Experience", value: "50+" },
      { label: "Industries Served", value: "20+" },
      { label: "Custom Products", value: "1,200+" },
      { label: "Quality Pass Rate", value: "99.7%" },
    ],
  },
  quickContact: {
    message: "Having trouble with rubber products? We will solve it for you.",
    quoteRequest: "Get a Quote",
  },
  aboutPreview: {
    eyebrow: "About Us",
    headline1: "A technology-driven manufacturer that",
    headline2: "solves customer problems",
    desc: "Hankuk Rubber Tech. Co., Ltd. develops and manufactures rubber products across diverse industries, acting as a technology partner that analyzes the technical challenges our customers face and delivers solutions. We aim to be an engineering company that offers consulting beyond simple manufacturing.",
    stats: [
      { num: "50+", label: "Years\nof Heritage" },
      { num: "1,200+", label: "Custom\nProjects" },
      { num: "ISO", label: "Quality\nManagement" },
    ],
    detailBtn: "Learn More",
    productsBtn: "Product Lineup",
    floatingTitle: "50 Years of\nEngineering Trust",
    badge: "Verified Manufacturer",
  },
  quality: {
    eyebrow: "Quality & Technology",
    title: "Trust Proven by Quality and Technology",
    desc: "We supply products our customers can trust through 50 years of compression molding expertise and a rigorous quality management system.",
    cards: [
      { icon: "ri-shield-check-line", title: "ISO 9001 / IATF 16949", desc: "Consistent quality assured by international quality management certifications" },
      { icon: "ri-flask-line", title: "R&D Division", desc: "KOITA-certified corporate research institute for continuous innovation" },
      { icon: "ri-building-2-line", title: "2,000㎡ Production Facility", desc: "30 presses from 50 to 1,300 tons with in-house compounding line" },
      { icon: "ri-global-line", title: "SINCE 1975", desc: "Over 50 years of heritage" },
    ],
  },
  strengths: {
    eyebrow: "Core Strengths",
    headline1: "We build",
    headline2: "solutions, not just products",
    desc: "A consistent process from design to mass production meets even the most demanding requirements. That is the difference 40 years of know-how makes.",
    items: [
      { no: "01", icon: "ri-tools-line", title: "Custom Rubber Product Development", desc: "One-stop service from analyzing customer requirements and drawing design to prototyping.", tag: "Custom Design" },
      { no: "02", icon: "ri-settings-3-line", title: "Industrial Rubber Parts", desc: "Mass production of precision rubber parts for automotive, electronics, construction, and heavy industry.", tag: "Industrial" },
      { no: "03", icon: "ri-stack-line", title: "Compression Molding Expertise", desc: "Stable production of high-quality rubber products with 50 years of compression molding technology.", tag: "Compression" },
      { no: "04", icon: "ri-pencil-ruler-2-line", title: "Mold Development Partnership", desc: "Precise realization of complex shapes through collaboration with specialized mold partners.", tag: "Tooling" },
      { no: "05", icon: "ri-line-chart-line", title: "Small to Large Batch Production", desc: "Flexible response from a single prototype to 1 million units per month.", tag: "Flexible MOQ" },
      { no: "06", icon: "ri-shield-check-line", title: "Quality Control & Technical Support", desc: "ISO-based quality management with dedicated post-sale technical support engineers.", tag: "Quality" },
    ],
  },
  latestProducts: {
    eyebrow: "Latest Products",
    title: "Featured Products",
    desc: "Discover Hankuk Rubber Tech's representative products supplied to industrial sites from automotive to heavy industry.",
    viewAll: "View All Products",
    quoteRequest: "Get a Quote",
    detail: "View Details",
  },
  noticesTech: {
    noticeEyebrow: "Notice",
    noticeTitle: "Recent Notices",
    techEyebrow: "Technical",
    techTitle: "Recent Technical Data",
    viewAll: "View All",
    important: "Important",
    emptyNotices: "No notices registered.",
    emptyTech: "No technical data registered.",
  },
  cta: {
    eyebrow: "Solution Inquiry",
    headline1: "Worried about",
    headline2: "rubber products?",
    desc: "No drawings? No problem. Just send us a photo or a sample, and our engineers will analyze it and find a solution for you.",
    contactBtn: "Contact Us",
    quickContact: "Quick Contact",
    phone: "Phone",
    email: "Email",
    hours: "Business Hours",
    hoursValue: "Weekdays 09:00 - 18:00",
  },
};